"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const Report_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/Report"));
const SampleCoreMetadata_1 = __importDefault(require("./SampleCoreMetadata"));
const SampleCSVMetadata_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/metadata/SampleCSVMetadata"));
class Sample {
    constructor() {
        this.code = '';
        this.name = '';
        this.coreMetadata = new SampleCoreMetadata_1.default;
        this.csvMetadata = new SampleCSVMetadata_1.default;
        this.report = new Report_1.default();
        this.alchemy = false;
        this.alchemy_samples = null;
    }
    static fromRaw(raw) {
        //console.log(raw);
        const sample = new Sample();
        sample.code = raw.code;
        sample.name = raw.name || '';
        sample.coreMetadata = SampleCoreMetadata_1.default.fromRaw(raw);
        // Report
        sample.report = Report_1.default.fromRaw(raw.report);
        return sample;
    }
    //
    //
    //
    get firstCode() {
        if (this.alchemy_samples)
            return this.alchemy_samples[0].code;
        return this.code;
    }
    //
    //
    //
    getTooltipMetadata() {
        const lines = [];
        lines.push(`Code: ${this.code}`);
        lines.push(`Date: ${this.coreMetadata.date}`);
        lines.push(`Plant year: ${this.coreMetadata.plant_year}`);
        lines.push(`Soil type: ${this.coreMetadata.soil_type_id}`);
        lines.push(`Organic: ${this.coreMetadata.org_practises}`);
        return lines.join('\n');
    }
    //
    // Filter stuff
    //
    checkFilters(filters) {
        if (!filters.length)
            return true;
        return filters.every(f => this.checkFilter(f));
    }
    checkFilter(filterWV) {
        switch (filterWV.filter.type) {
            case 'date':
                return this.checkFilterDate(filterWV);
            case 'number':
                return this.checkFilterNumber(filterWV);
            case 'list':
                return this.checkFilterList(filterWV);
            case 'boolean':
                return this.checkFilterBoolean(filterWV);
        }
        console.warn("Filter not supported yet", filterWV.filter.type);
        return false;
    }
    checkFilterDate(filterWV) {
        const date = this.retrieveValueForFilterOrGroup(filterWV.filter);
        if (!date)
            return false;
        const mdate = (0, moment_1.default)(date);
        if (!mdate.isValid())
            return false;
        if (filterWV.value.type === 'date_range') {
            if (filterWV.value.date_from) {
                if (mdate.isBefore(filterWV.value.date_from))
                    return false;
            }
            if (filterWV.value.date_to) {
                if (mdate.isAfter(filterWV.value.date_to))
                    return false;
            }
            return true;
        }
        else if (filterWV.value.type === 'date_simple') {
            return Math.abs(mdate.diff(filterWV.value.date_value, 'days')) < 1;
        }
        console.warn("TodOOooooo");
    }
    checkFilterNumber(filterWV) {
        const num = this.retrieveValueForFilterOrGroup(filterWV.filter);
        if (num === null)
            return false;
        if (isNaN(num))
            return false;
        if (filterWV.value.type === 'number_range') {
            if (filterWV.value.number_from) {
                if (num < filterWV.value.number_from)
                    return false;
            }
            if (filterWV.value.number_to) {
                if (num > filterWV.value.number_to)
                    return false;
            }
            return true;
        }
        else if (filterWV.value.type === 'number_simple') {
            return filterWV.value.number_value === num;
        }
    }
    checkFilterList(filterWV) {
        let option = this.retrieveValueForFilterOrGroup(filterWV.filter);
        if (option === null)
            return false;
        option += '';
        if (!filterWV.value.item_list)
            return false;
        for (const opt of filterWV.value.item_list) {
            if (opt === option)
                return true;
        }
        return false;
    }
    checkFilterBoolean(filterWV) {
        let option = this.retrieveValueForFilterOrGroup(filterWV.filter);
        if (option === null)
            return false;
        return option === filterWV.value.boolean_value;
    }
    // TODO Create a base class for this
    retrieveValueForFilterOrGroup(item) {
        if (item.origin === 'core') {
            if (item.sample_path in this.coreMetadata) {
                return this.coreMetadata[item.sample_path];
            }
            else {
                return undefined;
            }
        }
        else {
            return this.csvMetadata.getValue(item.id);
        }
    }
    //
    // Search stuff
    //
    checkFilterText(text) {
        const itext = text.toLowerCase();
        const strings = [];
        strings.push(this.code);
        strings.push(this.name);
        return strings.some(s => s.toLowerCase().includes(itext));
    }
    resetCSVMetadata() {
        this.csvMetadata.reset();
    }
    addCSVMetadatata(id, value) {
        this.csvMetadata.addValue(id, value);
    }
}
exports.default = Sample;
